export default "__VITE_ASSET__fe31156d__"